import axios from "axios";
import { useEffect, useState } from "react";
import { useParams, useLocation, Link } from "react-router-dom";
import { BASE_URL } from "../../constant/api";
import SearchNav from "../../components/Home/SearchNav/SearchNav";
import MyOrderProductCard from "../../components/Orders/MyOrderProductCard";
import CategoryViewProductCard from "../../components/Home/CategoryViewProductCard/CategoryViewProductCard";
import ProductCard from "../../components/Home/ProductCard/ProductCard";
import CircleCard from "../../components/Home/CircleCard/CircleCard";
import CircularImageList from "../../components/Home/CircularImageList/CircularImageList";
import { GoHomeFill } from "react-icons/go";

function CategoryView() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const location = useLocation();
    const { categoryId } = useParams();
    const queryParams = new URLSearchParams(location.search);
    const subcategoryId = queryParams.get("sub"); // Move this above its usage

    const [Categories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [categoriesName, setCategoriesName] = useState("Category");
    const [products, setProducts] = useState([]);
    const [trendingProduct, setTrendingProducts] = useState([]);
    const [fastMovingProduct, setFastMovingProducts] = useState([]);

    const fetchData = async (url, setter) => {
        try {
            const response = await axios.get(url);
            // console.log(url, response);
            const data = response.data.Data || response.data.data;
            if (data) {
                setter(data);
            }
            
        } catch (error) {
            console.error(`Error fetching data from ${url}:`, error);
            const errorMessage = error.response?.data?.message || "Failed to fetch data";
            console.log("Fetch data error message:", errorMessage);
        }
    };

    useEffect(() => {
        fetchData(`${BASE_URL}/categories/`, setCategories);
        fetchData(`${BASE_URL}/categories/${categoryId}/subcategory/`, setSubCategories);
        fetchData(`${BASE_URL}/products/fast-moving/`, setFastMovingProducts);
        fetchData(`${BASE_URL}/products/trending/`, setTrendingProducts);
    }, [categoryId]);



    useEffect(() => {
        
        const url =
            !subcategoryId || subcategoryId === 'all'
                ? `${BASE_URL}/categories/${categoryId}/products/`
                : `${BASE_URL}/categories/subcategories/${subcategoryId}/product/`;


        axios
            .get(url)
            .then((res) => {
                const data = res.data.Data || res.data.data;
                console.log(data);
                setProducts(data || []);
            })
            .catch((err) => console.error("Error fetching products:", err));
    }, [categoryId, subcategoryId]);

    return (
        <>
            {/* <SearchNav /> */}
            <div className="mt-5">
                <div className="bg-white py-3 my-5">
                    <CircleCard data={Categories} id={categoryId} bg="bg-white" title="Categories"  icon={<GoHomeFill />} />
                </div>
                <div className="bg-white my-2">
                    <CircularImageList data={subCategories} bg="bg-white" title="Sub Categories" id={subcategoryId} categoryId={categoryId} />
                </div>

            </div>
            <div className="flex mx-2 my-2 md:m-0 flex-col md:flex-row justify-between mt-4">
                {/* Product List */}
                <div className="flex-grow grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 w-full md:w-2/3 gap-2 p-3 md:p-6">
                    {products && products.length > 0 ? (
                        products.map((product) => (
                            <CategoryViewProductCard key={product.id} product={product} />
                        ))
                    ) : (
                        <p className="text-start mx-10 text-base text-gray-500 mt-4">No products available</p>
                    )}
                </div>
                {/* Trending Products */}
                <div className="w-full md:w-1/3 mt-6 md:mt-0 md:ml-6">
                    <MyOrderProductCard
                        products={trendingProduct}
                        title="Trending Products"
                        layout="vertical-3-horizontal-2"
                    />
                </div>
            </div>
            <div className="w-full mt-6">
                <ProductCard
                    products={fastMovingProduct}
                    title="Fast Moving Items"
                />
            </div>
        </>
    );
}

export default CategoryView;
